import { InjectionToken } from '@angular/core';

export interface Translations {
  [key: string]: any;
}

export interface PhraseAppTranslations extends Translations {
  [key: string]: {
    app?: object;
    rtr?: object;
    rtu?: object;
    rti?: object;
    rto?: object;
  };
}

export interface LanguageConfig {
  languages: string[];
  defaultLanguage: string;
}

export interface I18nConfig {
  editor?: boolean;
  phraseAppProjectId: string;
}

export const I18N_CONFIG_TOKEN = new InjectionToken<I18nConfig>('I18n_CONFIG');
export const CONTEXT_EDITOR_ENABLED = new InjectionToken<boolean>('CONTEXT_EDITOR_ENABLED');
export const ENABLE_TRANSLATION_UI_KEY = 'enable_translation_ui';
export const LOCALE = new InjectionToken<string>('LOCALE');
export const LANGUAGE_CONFIG = new InjectionToken<LanguageConfig>(
  'Available languages and default',
);
